import ICidadeResponse from '../entities/CidadeResponse'
import { ICidadeRepository } from '../repositories/ICidadeRepository'

export interface IFindByNome {
  execute(cidade: string): Promise<ICidadeResponse>
}

export default class IFindByNomeImpl implements IFindByNome {
  constructor(private readonly cidadeRepository: ICidadeRepository) {}

  public async execute(cidade: string): Promise<ICidadeResponse> {
    const response = await this.cidadeRepository.findByNome(cidade)

    return response
  }
}
